import { Injectable } from '@angular/core';
import {
  MCAuthoritiesEventsCivilAdministration,
  MCCustomFunctionsParams,
} from '@maslul/common-services';

@Injectable({
  providedIn: 'root',
})
export class MIAuthoritiesEventsCivilAdministration extends MCAuthoritiesEventsCivilAdministration {
  override shippingTypeInit(customFunctionsObj: MCCustomFunctionsParams) {
    throw new Error('Method not implemented.');
  }
}
